interface CarKeySource {
  id: string;
  allowedWeightInTon?: number;
  carType?: string;
}

export function trainCarKey(car: CarKeySource, weight: number | string = car.allowedWeightInTon): string {
  return car.id + weight + car.carType;
}
